module.exports = __webpack_public_path__ + "img/android-logo.8060a012.svg";